import React from "react";
import PropTypes from "prop-types";
// import { useStyles } from "./styles";
import ScrollableTabs from "../../../../components/TabPanel/index";
import {
  triggerSimActivationAPI,
  triggerSimActivationCsvAPI,
  triggerDailyActivatingOutletAPI,
  triggerDailyActivatingOutletCsvAPI,
  triggerTop5RetailersAPI,
  triggerBottom5RetailersAPI,
  triggerLast7DaysAPI,
  triggerLast7DaysCsvAPI,
  triggerCafPendencyAPI,
  triggerCafPendencyCsvAPI,
  triggerSimActivationJiophoneAPI,
  triggerSimActivationJiophoneCsvAPI
} from "../../../../redux/actions/index";

export default function SimConnectivity(props) {
  const {
    activationModel: {
      secTilesMasterTxDtos: tilesDto = [],
      isSectionActive = "",
      sectionName,
    },
    timestamp,
    ...other
  } = props;
  if (isSectionActive === "Y") {
    if (tilesDto.length) {
      return (
        <ScrollableTabs
          sectionHeader={sectionName}
          section={sectionName}
          tabsDto={tilesDto}
          sortingProperty="tileId"
          sortingOrder="asc"
          tabVariant="scrollable"
          color="#9cf26e"
          triggerSimActivationAPI={triggerSimActivationAPI}
          triggerSimActivationCsvAPI={triggerSimActivationCsvAPI}
          triggerDailyActivatingOutletAPI={triggerDailyActivatingOutletAPI}
          triggerDailyActivatingOutletCsvAPI={
            triggerDailyActivatingOutletCsvAPI
          }
          triggerTop5RetailersAPI={triggerTop5RetailersAPI}
          triggerBottom5RetailersAPI={triggerBottom5RetailersAPI}
          triggerLast7DaysAPI={triggerLast7DaysAPI}
          triggerLast7DaysCsvAPI={triggerLast7DaysCsvAPI}
          triggerCafPendencyAPI={triggerCafPendencyAPI}
          triggerCafPendencyCsvAPI={triggerCafPendencyCsvAPI}
          triggerSimActivationJiophoneAPI={triggerSimActivationJiophoneAPI}
          triggerSimActivationJiophoneCsvAPI={triggerSimActivationJiophoneCsvAPI}
          timeStampArr={timestamp}
          {...other}
        />
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}

SimConnectivity.propTypes = {
  tilesDto: PropTypes.arrayOf(
    PropTypes.shape({
      tileId: PropTypes.number,
      tileName: PropTypes.string,
      isTileActive: PropTypes.string,
      tileEndPointUrl: PropTypes.string,
      moduleSecMasterTransactionDto: PropTypes.any,
    })
  ),
};
